var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "title" }, [
    _c("div", { staticClass: "title__text" }, [
      _c("span", { staticClass: "title__text-date" }, [
        _vm._v(_vm._s(_vm.date)),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "title__text-author" }, [
        _vm._v(_vm._s(_vm.author)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }